import { getDataFromLocalStorage } from '../../config/utils';
import { LOCAL_STORAGE } from '../../config/constants';

const states = {
  chats_details: {
    is_socket_connected: false,
    untagged_chats: {},
    live_chats: {},
    unread_live_message_count: getDataFromLocalStorage(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT, {}),
    unseen_live_chats_stall_count: getDataFromLocalStorage(LOCAL_STORAGE.UNSEEN_LIVE_CHATS_STALL_COUNT, {}),
    selected_active_chat_type: null,
    selected_active_chat_id: null,
    active_chats: {},
    accepting_chat: null,
    rejecting_chat: null,
    loaders: {
      untagged_chats_loading: false,
      tags_loading: false,
      chat_page_joining: false,
      customer_profile_loading: false
    }
  }
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/chats_details/states.js